module.exports = __webpack_public_path__ + "img/magic_paradise.6f43cdde.png";